"use strict";
import Handlebars from "handlebars/dist/handlebars.js";
import { displayGenericError, serviceNetworkError } from "../failhandler";

var removeBlockedBanners = (function () {

    var blockedTable = $('.t-blocked-banners');

    if (blockedTable.length > 0) {


        var main = $('#main'),
            source = $("#blocked-banners-template").html(),
            template = Handlebars.compile(source),
            responseWrap = $('.response-wrapper'),
            noActiveBlocks = $('.no-active-blocks');

        setTimeout(function () {
            checkIfTableIsEmpty();
        }, 100);

        main.on('click', '.remove-blocked-banner', function (e) {

            e.preventDefault();

            var bannerPageId = $(this).data("bannerpageid"),
                data = {
                    "bannerPageId": bannerPageId
                },
                item = $(this).closest('tr');

            var ajaxRequest = $.ajax({
                url: SETTINGS.services.admin.methods.getRemovedBlockedBanners,
                data: JSON.stringify(data)
            });

            item.addClass('remove');

            ajaxRequest.done(doneHandler);
            ajaxRequest.fail(failHandler);
        });
    }

    function doneHandler(response) {

        if (response.Success) {

            $('#main .t-blocked-banners').find('tr.remove').remove();

            checkIfTableIsEmpty();

        } else {

            blockedTable.prev().prepend($('#remove-blocked-loader'));

            $('#main .t-blocked-banners').find('tr.remove').removeClass('remove');

            displayGenericError(responseWrap);

        }

    }

    function failHandler(jqXHR, textStatus, errorThrown) {
        serviceNetworkError(responseWrap);
    }

    function checkIfTableIsEmpty() {
        var items = $('#main .t-blocked-banners tbody tr').length;

        if (items === 0) {
            blockedTable.addClass('hidden');
            noActiveBlocks.removeClass('hidden');
        }
    }

})();